var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-tel-input.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown-selection.js";
import countryCodes from "country-codes-list";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { getFlagByLangAbbreviation } from "../helpers/flag.js";
var XTelInput = class extends FormField {
  constructor() {
    super(...arguments);
    this.placeholderMode = this.defaults.placeholderMode;
    this.searchable = false;
    this._selectables = Object.entries(
      countryCodes.customList("countryCode", `+{countryCallingCode}`)
    ).sort((a, b) => +a[1] - +b[1]).reduce((acc, curr) => {
      if (acc.map(([_, countryCode]) => countryCode).includes(curr[1]))
        return acc;
      acc.push(curr);
      return acc;
    }, []);
    this._countryCodeSelected = "";
    this._numberEntered = "";
  }
  get _countryCode() {
    return this._selectables.find(([country, countryCode]) => this.value.value?.startsWith(countryCode))?.[1] ?? "+49";
  }
  get _phoneNumber() {
    return (this.value.value?.replace(this._countryCode, "") ?? "").trim();
  }
  render() {
    if (!this._selectables.length)
      return nothing;
    return xComponents(html`
      <x-flex horizontal crossaxis-end space="md">
        <x-dropdown-selection
          flex-none
          placeholder-mode=${this.placeholderMode}
          .value=${this._countryCode}
          .selectables=${this.searchable ? null : this._selectables.map(([_, countryCode]) => countryCode)}
          .renderItem=${(countryCode) => this._renderDropdownItem(countryCode, true)}
          .renderSelected=${(countryCode) => this._renderDropdownItem(countryCode)}
          .search=${this.searchable ? (searchString) => (searchString ? this._selectables.filter(
      (selectable) => selectable[1].includes(searchString) || selectable[1].includes(searchString.replace("00", "+"))
    ) : this._selectables).map(([_, countryCode]) => countryCode) : void 0}
          @value-picked=${(e) => {
      this._countryCodeSelected = e.detail.value;
      this._combineValues(this._countryCodeSelected, this._numberEntered || this._phoneNumber);
    }}
        ></x-dropdown-selection>
        <x-input
          flex
          placeholder-mode=${this.placeholderMode}
          placeholder=${ifDefined(this.placeholder)}
          error=${ifDefined(this.error)}
          .value=${this._phoneNumber}
          @value-picked=${(e) => {
      this._numberEntered = e.detail.value?.trim().replace(/^0+/, "");
      this._combineValues(this._countryCodeSelected || this._countryCode, this._numberEntered);
    }}
        ></x-input>
      </x-flex>
    `);
  }
  _renderDropdownItem(countryCode, padding = false) {
    if (!countryCode)
      return nothing;
    const country = this._selectables.find(([_, cC]) => cC === countryCode)[0];
    return xComponents(html`
      <x-flex
        horizontal
        crossaxis-center
        space="xxs"
        ${css(padding ? { padding: `${this.spacing.sm} ${this.spacing.md}` } : {})}
      >
        <img flex-none src=${getFlagByLangAbbreviation(country)} ${css({ height: "20px", width: "30px" })} />
        <x-text flex ${css({ textAlign: "center", whiteSpace: "nowrap" })}> ${countryCode} </x-text>
      </x-flex>
    `);
  }
  _combineValues(countryCode, phoneNumber) {
    const resultingTelString = `${countryCode}${phoneNumber}`;
    if (resultingTelString.length < 8)
      return this.error = this.translateError ? this.translateError("phone_too_short") : "Nummer ist zu kurz";
    if (this._validateTelString(resultingTelString)) {
      this._numberEntered = "";
      this._countryCodeSelected = "";
      this.value.next(resultingTelString);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
    } else
      this.error = this.translateError ? this.translateError("phone_invalid") : "Nummer ist nicht g\xFCltig";
  }
  _validateTelString(telString) {
    const regex = /^\+(?:[0-9]●?){5,14}[0-9]$/;
    return regex.test(telString);
  }
};
__decorateClass([
  property({ reflect: true, attribute: "placeholder-mode" })
], XTelInput.prototype, "placeholderMode", 2);
__decorateClass([
  property({ reflect: true })
], XTelInput.prototype, "placeholder", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], XTelInput.prototype, "searchable", 2);
__decorateClass([
  state()
], XTelInput.prototype, "_selectables", 2);
XTelInput = __decorateClass([
  customElement("x-tel-input")
], XTelInput);
export {
  XTelInput
};
